/**
 * @class QuickShop
 * @extends HTMLElement
 */
class QuickShop extends HTMLElement {
  connectedCallback() {
    // Close the popup quickshop on cart update
    this.querySelector('product-form')?.addEventListener('cart-updated', () => {
      this.closest('section-lightbox')?.close();
    });
  }
}

customElements.define('quick-shop', QuickShop);
